import { defaultObjects, rootModuleId } from "@app/const";
import DesignerSetting from "@app/DesignerSetting";
import {
    DesignClass,
    DesignItemType,
    ExitObjectOutputType,
    FunctionType,
    NodeTypeName,
    ObjectClass
} from "@app/types";
import { createUuid } from "./functions";

/**
 * @import {
 *   Design,
 *   DesignIntent,
 *   DesignModule,
 *   DesignObject
 * } from '../types';
 */

/**
 * Static seeder
 * @module Seed
 */
export class Seed {
    /**
     * Get a completely empty app, without anything in the start module or any other settings
     * @returns {Object}
     */
    static getPurelyEmptyApp() {
        return {
            "_id": createUuid(),
            "designer": DesignerSetting.s.version,
            "client": "",
            "application": "",
            "version": "",
            "components": {
                "intents": [],
                "modules": [],
                "objects": [],
                "variables": []
            }
        };
    }

    /**
     * Get a blank starter app, with some default settings
     * @param {string} client
     * @param {string} application
     * @param {string} version
     * @returns {Design}
     */
    static getBlankApp(client = "Untitled client", application = "Untitled app", version = "1.0.0") {
        var app = this.getPurelyEmptyApp();
        app.client = client;
        app.application = application;
        app.version = version;
        app.repoClient = client;
        app.fillerPrompts = [];
        app.repoApplication = application;
        app.repoVersion = version;
        app.csvData = [];
        app.globalErrorHandling = {
            errorHandling: "c2fd95fa-8b5f-4bd5-bd92-4fe3ca784ddb",
            postProcessingCustom: null,
            sessionStart: "e9676ff6-cc92-4fcb-9b62-482eebc77da4",
            userHangUp: "8be14106-6031-47ac-a794-1774a5495d52"
        };
        app.globalExceptionHandling = {
            "exception": "f414d315-af49-4723-a16f-e9aeaa2df6e1",
            "timeout": "802a9bde-80b8-429c-8cba-d9d21def31a0"
        };
        app.languages = [
            {
                "language": "en-US",
                "voice": "Phil"
            }
        ];
        app.components.objects.push(
            {
                "id": createUuid(),
                "name": "Begin",
                "type": "object",
                "_class": ObjectClass.begin,
                "props": {
                    "iconClass": "log-in",
                    "config": {
                        "description": "Entry point of the module"
                    }
                }
            }
        );
        app.components.modules.push(
            {
                "id": rootModuleId,
                "name": "Start",
                "type": "module",
                "_class": DesignClass.module,
                "props": {
                    config: {}
                },
                "version": 1,
                "versions": {
                    "1": {
                        "version": 1,
                        "flow": {
                            "offsetX": 0,
                            "offsetY": 0,
                            "zoom": 100,
                            "links": [],
                            "nodes": [
                                {
                                    "id": "65200c36-5b78-4c57-be36-90b9f8acba5a",
                                    "_class": ObjectClass.begin,
                                    "x": 340,
                                    "y": 200,
                                    "name": "Begin",
                                    "props": {
                                        "colorClass": "purple",
                                        "iconClass": "log-in",
                                        "error": {},
                                        "config": {
                                            "description": "Entry point of the module"
                                        }
                                    }
                                }
                            ]
                        }
                    }
                },
                "localVariables": []
            }
        );
        app.components.intents.push(
            {
                "id": "b74b71c6-93d8-4cc7-b2d7-ddeba76e84a1",
                "name": "ARE_YOU_REAL",
                "type": "intent",
                "_class": DesignClass.intent,
                "props": {
                    "iconClass": "radio",
                    "config": {
                        "description": "",
                        "lockName": true
                    }
                }
            },
            {
                "id": "0ded9832-4774-497d-9bb8-8171bb893953",
                "name": "I_HAVE_A_QUESTION",
                "type": "intent",
                "_class": DesignClass.intent,
                "props": {
                    "iconClass": "radio",
                    "config": {
                        "description": "",
                        "lockName": true
                    }
                }
            },
            {
                "id": "3774547b-39b9-45a4-b5e3-f5f8c2c01ae5",
                "name": "WAIT",
                "type": "intent",
                "_class": DesignClass.intent,
                "props": {
                    "iconClass": "radio",
                    "config": {
                        "description": "",
                        "lockName": true
                    }
                }
            },
            {
                "id": "8d7806d9-e16c-4a47-87ea-2974073f4465",
                "name": "NO",
                "type": "intent",
                "_class": DesignClass.intent,
                "props": {
                    "iconClass": "radio",
                    "config": {
                        "description": "",
                        "lockName": true
                    }
                }
            },
            {
                "id": "8ee333bd-d7bd-49c0-849b-6b9d239fa588",
                "name": "YES",
                "type": "intent",
                "_class": DesignClass.intent,
                "props": {
                    "iconClass": "radio",
                    "config": {
                        "description": "",
                        "lockName": true
                    }
                }
            },
                {
                "id": "33dca20a-387d-4d86-b32a-54876ce823c2",
                "name": "DTMF",
                "type": "intent",
                "_class": DesignClass.intent,
                "props": {
                    "iconClass": "radio",
                    "config": {
                        "description": "",
                        "lockName": true
                    }
                }
            },
            {
                "id": "286284be-112d-4bfb-8f87-a7b39f5e35c9",
                "name": "BACK_FROM_WAIT",
                "type": "intent",
                "_class": DesignClass.intent,
                "props": {
                    "iconClass": "radio",
                    "config": {
                        "description": "",
                        "lockName": true
                    }
                }
            },
            {
                "id": "a9e45f7b-a5a2-4e6c-8777-b48b84e3ee1a",
                "name": "COMPLAINT",
                "type": "intent",
                "_class": DesignClass.intent,
                "props": {
                    "iconClass": "radio",
                    "config": {
                        "description": "",
                        "lockName": true
                    }
                }
            },
            {
                "id": "83352e5b-bca5-4b08-b80c-6fa8fb8ed279",
                "name": "COMPLIMENT",
                "type": "intent",
                "_class": DesignClass.intent,
                "props": {
                    "iconClass": "radio",
                    "config": {
                        "description": "",
                        "lockName": true
                    }
                }
            },
            {
                "id": "388b1ab2-c039-4b8d-859a-263e39b1be8e",
                "name": "DONT_KNOW",
                "type": "intent",
                "_class": DesignClass.intent,
                "props": {
                    "iconClass": "radio",
                    "config": {
                        "description": "",
                        "lockName": true
                    }
                }
            },
            {
                "id": "9c3b1038-7148-4233-944a-4c55bcb076c4",
                "name": "ENGLISH",
                "type": "intent",
                "_class": DesignClass.intent,
                "props": {
                    "iconClass": "radio",
                    "config": {
                        "description": "",
                        "lockName": true
                    }
                }
            },
            {
                "id": "496492c9-17e0-4d64-a91d-72d00b958cc5",
                "name": "FOREIGN_LANGUAGE",
                "type": "intent",
                "_class": DesignClass.intent,
                "props": {
                    "iconClass": "radio",
                    "config": {
                        "description": "",
                        "lockName": true
                    }
                }
            },
            {
                "id": "ccf458c2-54a5-4e4d-8eb8-2bac9b728bfc",
                "name": "GARBLED",
                "type": "intent",
                "_class": DesignClass.intent,
                "props": {
                    "iconClass": "radio",
                    "config": {
                        "description": "",
                        "lockName": true
                    }
                }
            },
            {
                "id": "7333af2c-3d89-415c-be36-557193f9a332",
                "name": "GOODBYE",
                "type": "intent",
                "_class": DesignClass.intent,
                "props": {
                    "iconClass": "radio",
                    "config": {
                        "description": "",
                        "lockName": true
                    }
                }
            },
            {
                "id": "125cc0e3-ae2c-41e2-b27b-5d53d7ddcc6f",
                "name": "HELLO",
                "type": "intent",
                "_class": DesignClass.intent,
                "props": {
                    "iconClass": "radio",
                    "config": {
                        "description": "",
                        "lockName": true
                    }
                }
            },
            {
                "id": "e957ee15-3089-48e2-ac51-cbb7bacbd42b",
                "name": "HOW_ARE_YOU",
                "type": "intent",
                "_class": DesignClass.intent,
                "props": {
                    "iconClass": "radio",
                    "config": {
                        "description": "",
                        "lockName": true
                    }
                }
            },
            {
                "id": "71aba18c-40da-44f0-895d-e40c72a24d33",
                "name": "LIVE_AGENT",
                "type": "intent",
                "_class": DesignClass.intent,
                "props": {
                    "iconClass": "radio",
                    "config": {
                        "description": "",
                        "lockName": true
                    }
                }
            },
            {
                "id": "766a47a0-5640-432c-93b9-b8b7e56b3a74",
                "name": "NO_MATCH",
                "type": "intent",
                "_class": DesignClass.intent,
                "props": {
                    "iconClass": "radio",
                    "config": {
                        "description": "",
                        "lockName": true
                    }
                }
            },
            {
                "id": "03f6f66a-3c01-4a1d-a13e-e687099414b4",
                "name": "NOISE",
                "type": "intent",
                "_class": DesignClass.intent,
                "props": {
                    "iconClass": "radio",
                    "config": {
                        "description": "",
                        "lockName": true
                    }
                }
            },
            {
                "id": "ee63d257-cd1c-4b09-9600-f1a220dcccc3",
                "name": "NOT_TALKING_TO_ME",
                "type": "intent",
                "_class": DesignClass.intent,
                "props": {
                    "iconClass": "radio",
                    "config": {
                        "description": "",
                        "lockName": true
                    }
                }
            },
            {
                "id": "325e10ff-768c-4470-86e2-1b201f8da4f4",
                "name": "QUESTION",
                "type": "intent",
                "_class": DesignClass.intent,
                "props": {
                    "iconClass": "radio",
                    "config": {
                        "description": "",
                        "lockName": true
                    }
                }
            },
            {
                "id": "95af5521-7603-4fce-90fe-75fe0ae73a1f",
                "name": "REPEAT",
                "type": "intent",
                "_class": DesignClass.intent,
                "props": {
                    "iconClass": "radio",
                    "config": {
                        "description": "",
                        "lockName": true
                    }
                }
            },
            {
                "id": "109e8af8-b4cf-491e-b9d6-16414e0f9b77",
                "name": "SILENCE",
                "type": "intent",
                "_class": DesignClass.intent,
                "props": {
                    "iconClass": "radio",
                    "config": {
                        "description": "",
                        "lockName": true
                    }
                }
            },
            {
                "id": "f2df7e8c-8f4d-48de-a464-97b3be8ae205",
                "name": "SPANISH",
                "type": "intent",
                "_class": DesignClass.intent,
                "props": {
                    "iconClass": "radio",
                    "config": {
                        "description": "",
                        "lockName": true
                    }
                }
            },
            {
                "id": "6fecbce3-f841-46b6-b83f-db1280a5852f",
                "name": "SWEARING",
                "type": "intent",
                "_class": DesignClass.intent,
                "props": {
                    "iconClass": "radio",
                    "config": {
                        "description": "",
                        "lockName": true
                    }
                }
            },
            {
                "id": "c6951b68-e1ea-4bd1-9477-5bd48e298a0b",
                "name": "THANK_YOU",
                "type": "intent",
                "_class": DesignClass.intent,
                "props": {
                    "iconClass": "radio",
                    "config": {
                        "description": "",
                        "lockName": true
                    }
                }
            }
        );

        return app;
    }

    /**
     * Seed for common elements
     * @returns {{
     *   intents: [{
     *     category: 'common';
     *     items: DesignIntent[];
     *   }];
     *   modules: [{
     *     category: 'common';
     *     items: never[];
     *   }];
     *   objects: [{
     *     category: 'common';
     *     items: DesignObject[];
     *   }];
     *   variables: never[];
     * }}
     */
    static getElements() {
        return {
            "variables": [],
            "objects": [
                {
                    category: "common",
                    items: [
                        {
                            "id": "10e8cead-27e6-4d6e-acf0-5af33d81b957",
                            "name": "EXIT",
                            "type": "object",
                            "_class": ObjectClass.exit,
                            "props": {
                                "iconClass": "log-out",
                                "config": {
                                    "description": "Exit point of a module",
                                    //"exitHandling": "HANGUP"
                                    "exitHandling": "ENDPOINT",
                                    "outputs": [
                                        { "argumentName": null, "type": ExitObjectOutputType.value, "value": null, "varName": null, "intent": null }
                                    ],
                                    "type": ExitObjectOutputType.value,
                                    "value": null
                                }
                            }
                        },
                        {
                            "id": "e8442d4c-d3ed-4626-85dd-016e47b5ede8",
                            "name": "INPUT",
                            "type": "object",
                            "_class": ObjectClass.input,
                            "props": {
                                "iconClass": "mic",
                                "config": {
                                    "description": "User voice input",
                                    "sensitiveData":false,
                                    "localIntents":[]
                                }
                            }
                        },
                        {
                            "id": "588fd232-85d0-46bb-9f13-a61af83557a2",
                            "name": "FLUSH_PROMPTS",
                            "type": "object",
                            "_class": ObjectClass.flushPrompts,
                            "props": {
                                "iconClass": "zap",
                                "config": {
                                    "description": "Forces all queued prompts to be outputted without a Data Access / Input node.",
                                }
                            }
                        },
                        {
                            "id": "588fd232-85d0-56bb-9f13-a61af83557a3",
                            "name": "RICH_TEXT",
                            "type": "object",
                            "_class": ObjectClass.richText,
                            "props": {
                                "iconClass": "codepen",
                                "config": {
                                    "description": "Rich Text.",
                                }
                            }
                        },
                        {
                            "id": "588fd232-85d0-56bb-9f13-a61af83557a4",
                            "name": "BANNER",
                            "type": "object",
                            "_class": ObjectClass.banner,
                            "props": {
                                "iconClass": "radio",
                                "config": {
                                    "description": "A custom, configurable message.",
                                }
                            }
                        },
                        {
                            "id": "588fd232-85d0-56bb-9f13-a61af83557a2",
                            "name": "WITH_FILLER",
                            "type": "object",
                            "_class": ObjectClass.withFiller,
                            "props": {
                                "iconClass": "codepen",
                                "config": {
                                    "description": "A placeholder node to be replaced by any module or object.",
                                    "referenceNodeTimeout": 5
                                }
                            }
                        },
                        {
                            "id": "ba174a90-aaf3-4584-a648-f215e0408bde",
                            "name": "LOOP ESCALATION",
                            "type": "object",
                            "_class": ObjectClass.loopEscalation,
                            "props": {
                                "iconClass": "refresh-cw",
                                "config": {
                                    "description": "Transition caller into an interacting with an agent without the IVA application terminating",
                                    "sensitiveData":false
                                }
                            }
                        },
                        {
                            "id": "54776381-08a6-47c2-b940-a94fcecd2a47",
                            "name": "PROMPT",
                            "type": "object",
                            "_class": ObjectClass.prompt,
                            "props": {
                                "iconClass": "message-square",
                                "config": {
                                    "description": "Prompt user with predefined text",
                                    "text":{
                                        "en-US":""
                                    },
                                   
                                    "bargeable": "DISABLED",
                                    "dynamicPromptType": "TTP",
                                    "repeatable": true
                                }
                            }
                        },
                        {
                            "id": "2ccdb2f3-3fdc-4215-842f-f1eef05b545c",
                            "name": "TASK_ORCHESTRATION",
                            "type": "object",
                            "_class": ObjectClass.taskOrchestration,
                            "props": {
                                "iconClass": "layout",
                                "config": {
                                    "description": "Task Orchestration Node",
                                    "type": "FORM",
                                    "endTask": true
                                }
                            }
                        },
                        {
                            "id": "54776381-08a6-47c2-b940-a94fcecd2a48",
                            "name": "SAVE_PROMPT",
                            "type": "object",
                            "_class": ObjectClass.savePrompt,
                            "props": {
                                "iconClass": "save",
                                "config": {
                                    "channel": {},
                                    "description": "Prompt saved for playing later",
                                    "promptId": "",
                                    "text": {}
                                }
                            }
                        },
                        {
                            "id": "54776381-08a6-47c2-b940-a94fcecd2a49",
                            "name": "PLAY_SAVED_PROMPT",
                            "type": "object",
                            "_class": ObjectClass.playSavedPrompt,
                            "props": {
                                "iconClass": "play",
                                "config": {
                                    "description": "Play previously saved Prompt",
                                    "promptId": "",
                                    "key": "TRANSFER"
                                }
                            }
                        },

                        {
                            "id": "0cf5e88e-c7fc-43e6-8f75-0cd1b02a461f",
                            "name": "CUSTOM",
                            "type": "object",
                            "_class": ObjectClass.custom,
                            "props": {
                                "iconClass": "cpu",
                                "config": {
                                    "description": "Run custom script",
                                    "functionType": FunctionType.custom,
                                    "function": {
                                        "script":""
                                    }
                                }
                            }
                        },
                        {
                            "id": "dc71ee4a-8b27-494e-9f0d-254c339c080a",
                            "name": "REPORTING_TAG",
                            "type": "object",
                            "_class": ObjectClass.report,
                            "props": {
                                "iconClass": "activity",
                                "config": {
                                    "description": "Reporting tag"
                                }
                            }
                        },
                        {
                            "id": "dc71ee4a-8b27-494e-9f0d-294c339c080a",
                            "name": "DTMF_MENU",
                            "type": "object",
                            "_class": ObjectClass.dtmf,
                            "props": {
                                "iconClass": "align-justify",
                                "config": {
                                    "description": "Dtmf Menu for Dtmf ",
                                    "inputTimeOut": [{
                                        "key": "InputTimeOut(ms)",
                                        "value": "3000"
                                    }],
                                    "selections": [
                                        {
                                            "key": "0",
                                            "value": "",
                                        },
                                        {
                                            "key": "1",
                                            "value": "",
                                        },
                                        {
                                            "key": "2",
                                            "value": "",
                                        },
                                        {
                                            "key": "3",
                                            "value": "",
                                        },
                                        {
                                            "key": "4",
                                            "value": "",
                                        },
                                        {
                                            "key": "5",
                                            "value": "",
                                        },
                                        {
                                            "key": "6",
                                            "value": "",
                                        },
                                       
                                        {
                                            "key": "7",
                                            "value": "",
                                        },
                                        {
                                            "key": "8",
                                            "value": "",
                                        },
                                        {
                                            "key": "9",
                                            "value": "",
                                        },
                                        {
                                            "key": "*",
                                            "value": "",
                                        },
                                        {
                                            "key": "#",
                                            "value": "",
                                        }
                                       
                                    ]
                                }
                            }
                        },
                        {
                            "id": "3932fc53-80b6-41a3-8c3c-02033d42a680",
                            "name": "DATA_ACCESS",
                            "type": "object",
                            "_class": ObjectClass.data,
                            "props": {
                                "iconClass": "server",
                                "config": {
                                    "description": "Data access interface",
                                    "httpRequestTimeout": 10
                                }
                            }
                        },
                        {
                            "id": "913b6767-3942-452d-a234-a6a9ee6b5c1a",
                            "name": "TABULAR_ROUTER",
                            "type": "object",
                            "_class": ObjectClass.tab,
                            "props": {
                                "iconClass": "grid",
                                "config": {
                                    "description": "Output result based on tabular data"
                                }
                            }
                        },
                        {
                            "id": "ba283863-cf3b-4731-a844-b90eae56b428",
                            "name": "DATA_ACCESS_COMPLETION",
                            "type": "object",
                            "_class": ObjectClass.dataAccessCompletion,
                            "props": {
                                "iconClass": "check",
                                "config": {
                                    "description": "Read results of asynchronous data access call that has already occurred",
                                    // DEVDES2-1475:defaulting "timeoutSeconds" to 10 sec 
                                    "timeoutSeconds": "10"
                                }
                            }
                        },
                        {
                            "id": "3d42a680-414d-441e-9aa6-d0b92284c9d2",
                            "name": "PROMPT_REFERENCE_NODE",
                            "type": "object",
                            "_class": ObjectClass.promptReference,
                            "props": {
                                "iconClass": "shuffle",
                                "config": {
                                    "description": ""
                                }
                            }
                        },
                        {
                            "id": "3d42a680-414d-441e-9aa6-d0b92284c9d1",
                            "name": "START_SIMULTANEOUS_SESSION",
                            "type": "object",
                            "_class": ObjectClass.session,
                            "props": {
                                "config": {
                                    "description": "Spawns new session",
                                    "channelName": "VOICE",
                                    "destination": null,
                                    "startModule": null
                                },
                                "colorClass": "yellow",
                                "iconClass": "external-link"
                            },
                            "DEFAULT_COLOR_CLASS": "yellow"
                        },
                        {
                            "id": "3d42a680-414d-441e-9aa6-d0b92284c9d7",
                            "name": "SIMULTANEOUS_SESSION_COMPLETION",
                            "type": "object",
                            "_class": ObjectClass.sessionCompletion,
                            "props": {
                                "config": {
                                    "description": "Completes new session",
                                    "timeoutSeconds": 30,
                                    "startSimultaneousSessionNode": null,
                                    "channelName": "",
                                    "blockProgress": false
                                },
                                "colorClass": "yellow",
                                "iconClass": "corner-left-down"
                            }
                        },
                        ...Object.entries(defaultObjects).map(([_, defaultObject]) => {
                            return {
                                ...defaultObject,
                                id: createUuid(),
                                name: defaultObject.props.nodeTypeName,
                                type: DesignItemType.object
                            };
                        })
                    ].map((item) => {
                        return {
                            ...item,
                            name: item.name.toUpperCase().replaceAll(' ', '_')
                        };
                    }).sort((itemA, itemB) => itemA.name.localeCompare(itemB.name))
                }
            ],
            "modules": [
                {
                    category: "common",
                    items: [
                        
                    ]
                }
            ],
            "intents": [
                {
                    category: "common",
                    items: [
                        {
                            "id": "42ce6c07-414d-441e-9aa6-d0b92284c9d2",
                            "name": "BLANK_INTENT",
                            "type": "intent",
                            "_class": DesignClass.intent,
                            "props": {
                                "iconClass": "radio",
                                "config": {
                                    "children": [],
                                    "commonIntent": null,
                                    "description": "Blank intent object",
                                    "droppable": false,
                                    "inARow": true,
                                    "localeData": {},
                                    "parents": [],
                                    "xAndOut": true
                                }
                            }
                        },
                    ]
                }
            ]
        };
    }

    /**
     * Get mapping between D1 common endpoint IDs to intent model
     * @return {Object}
     */
    static getCommonEndPointAsIntent() {
        return {
            "0b6f0667-9278-42ab-bbc3-e45e33d47433": {
                "id": createUuid(),
                "name": "RETURN_TO_ROOT_MODULE",
                "type": "intent",
                "_class": DesignClass.intent,
                "props": {
                    "iconClass": "radio",
                    "config": {
                        "lockName": true
                    }
                }
            },
            "177ad877-94d4-4e10-a018-d4b6607b38c9": {
                "id": createUuid(),
                "name": "RETURN_TO_PREVIOUS_INPUT",
                "type": "intent",
                "_class": DesignClass.intent,
                "props": {
                    "iconClass": "radio",
                    "config": {
                        "lockName": true
                    }
                }
            },
            "61594877-e093-47d9-ac9e-ddcf2aca9b8b": {
                "id": createUuid(),
                "name": "RETURN_TO_PREVIOUS_MODULE",
                "type": "intent",
                "_class": DesignClass.intent,
                "props": {
                    "iconClass": "radio",
                    "config": {
                        "lockName": true
                    }
                }
            },
            "76ebfd92-e465-4088-a9e8-f1d6e66f6394": {
                "id": createUuid(),
                "name": "HANG_UP",
                "type": "intent",
                "_class": DesignClass.intent,
                "props": {
                    "iconClass": "radio",
                    "config": {
                        "lockName": true
                    }
                }
            },
            "331d4dcb-5909-4d31-9cef-1d89badeee1a": {
                "id": createUuid(),
                "name": "TRANSFER",
                "type": "intent",
                "_class": DesignClass.intent,
                "props": {
                    "iconClass": "radio",
                    "config": {
                        "lockName": true
                    }
                }
            }
        };
    }

    /**
     * Get an object that represents a blank intent.
     * @param {string|undefined} name The intent name.
     * @param {string|undefined} description The intent description.
     * @param {boolean|undefined} isGlobalIntent If the intent is a global intent or not.
     * @returns {object} A blank intent object.
     */
    static getBlankIntentObject(name = 'BLANK_INTENT', description = 'Blank intent', isGlobalIntent = false) {
        const id = createUuid();

        return {
            id,
            name,
            type: 'intent',
            _class: DesignClass.intent,
            isGlobalIntent,
            props: {
                iconClass: 'radio',
                createdTime: window.apm.timestamp,
                lastLocalChange: window.apm.timestamp,
                parentComponentID: id,
                config: {
                    description
                }
            },
        };
    }

    /**
     * Get an object that represents a blank prompt.
     * @param {string} name The prompt name.
     * @param {string|undefined} promptText The prompt text.
     * @returns {object} A blank prompt object.
     */
    static getBlankPromptObject(name, promptText = '') {
        const id = createUuid();

        return {
            id,
            name,
            type: 'object',
            _class: ObjectClass.prompt,
            props: {
                iconClass: 'message-square',
                config: {
                    description: '',
                    inputs: [],
                    text: { 'en-US': promptText },
                    bargeable: 'DISABLED',
                    dynamicPromptType: 'TTP',
                    repeatable: true
                },
                nodeTypeName: NodeTypeName.prompt,
                createdTime: window.apm.timestamp,
                lastLocalChange: window.apm.timestamp,
                parentComponentID: id
            }
        };
    }

    /**
     * Get an object that represents a blank module.
     * @param {string} name The module name.
     * @param {string} description The module description.
     * @returns {DesignModule} A blank module object.
     */
    static getBlankModuleObject(name, description) {
        const id = createUuid();

        return {
            id,
            name,
            type: 'module',
            _class: DesignClass.module,
            props: {
                createdTime: window.apm.timestamp,
                lastLocalChange: window.apm.timestamp,
                iconClass: 'package',
                config: { description },
                parentComponentID: id,
                ref: id,
            },
            version: '1',
            versions: {
                1: {
                    version: '1',
                    flow: {
                        offsetX: 0,
                        offsetY: 0,
                        zoom: 100,
                        links: [],
                        nodes: [{
                            id: createUuid(),
                            _class: ObjectClass.begin,
                            x: 720,
                            y: 80,
                            name: 'Begin',
                            props: {
                                colorClass: 'purple',
                                iconClass: 'log-in',
                                lastLocalChange: window.apm.timestamp,
                                timeAddedToFlow: window.apm.timestamp,
                                error: {},
                                config: { description: 'Entry point of the module' }
                            }
                        }]
                    }
                }
            },
            localVariables: []
        };
    }

    /**
     * Get an object that represents a blank module node.
     * @param {string} name The module node name.
     * @param {object|undefined} props The module node props.
     * @returns {object} A blank module node object.
     */
    static getBlankModuleNodeObject(name, props = {}) {
        return {
            id: createUuid(),
            _class: DesignClass.module,
            name,
            type: 'module',
            x: 720,
            y: 220,
            props
        };
    }

    /**
     * Get an object that represents a blank return to root exit module node.
     * @param {string} name The module node name.
     * @param {string|number} parentComponentID The module node parent component ID.
     * @param {object|undefined} extraProps An object with extra props for the module node.
     * @returns {object} A blank module node object.
     */
    static getBlankReturnToRootExitModuleNode(name, parentComponentID, extraProps = {}) {
        return {
            id: createUuid(),
            _class: ObjectClass.exit,
            type: 'object',
            x: 720,
            y: 360,
            name,
            props: {
                nodeTypeName: NodeTypeName.exit,
                colorClass: 'purple',
                iconClass: 'log-out',
                error: {},
                createdTime: window.apm.timestamp,
                config: {},
                lastLocalChange: window.apm.timestamp,
                timeAddedToFlow: window.apm.timestamp,
                permission: {},
                parentComponentID,
                ...extraProps
            }
        };
    }

    /**
     * Get an object that represents a blank module flow link (connection on the UI).
     * @param {string|number} source The source of the link (starting point).
     * @param {string|number} target The target of the link (ending point).
     * @param {Array<{ x: number, y: number }>} points The link coordinates within the canvas.
     * @returns {object} A blank module flow link object.
     */
    static getBlankModuleFlowLinkObject(source, target, points) {
        return {
            id: createUuid(),
            _class: DesignClass.link,
            source,
            sourcePort: 'bottom',
            target,
            targetPort: 'top',
            points,
            props: {
                nodeTypeName: NodeTypeName.link,
                colorClass: 'primary',
                error: {},
                config: {
                    condition: [],
                    serializedCondition: 'true'
                },
                permission: {},
                lastLocalChange: window.apm.timestamp
            }
        };
    }

    /**
     * Get an object that represents a blank intent condition properties.
     * @param {string|number} intentId The intent ID.
     * @returns {object} A blank intent condition properties object.
     */
    static getBlankIntentConditionPropertiesObject(intentId) {
        return {
            id: createUuid(),
            _class: DesignClass.condition,
            props: {
                nodeTypeName: NodeTypeName.condition,
                colorClass: 'primary',
                config: {
                    name: '',
                    condition: [],
                    description: '',
                    inputs: [],
                    intent: intentId,
                    serializedCondition: ''
                }
            }
        };
    }
}

export default Seed;
